/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MonitorwerbungService {
    /**
     * Get Hockey Hcp
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getHockeyHcpMonitorwerbungHockeyHcpGet(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/monitorwerbung/hockey/hcp',
        });
    }
    /**
     * Get By Team And Language
     * @param teamId
     * @param lang
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getByTeamAndLanguageMonitorwerbungTeamIdGet(
        teamId: number,
        lang: string = 'de',
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/monitorwerbung/{team_id}',
            path: {
                'team_id': teamId,
            },
            query: {
                'lang': lang,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get By Team And Language And Timestamp
     * @param teamId
     * @param timestamp
     * @param lang
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getByTeamAndLanguageAndTimestampMonitorwerbungTeamIdTimestampGet(
        teamId: number,
        timestamp: string,
        lang: string = 'de',
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/monitorwerbung/{team_id}/{timestamp}',
            path: {
                'team_id': teamId,
                'timestamp': timestamp,
            },
            query: {
                'lang': lang,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
